// Register a service that will be used by both unit tests and backend-less development
v11nApp.service('VisualsServiceMock', function() {
});